import React from 'react';
import { Link, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import { Button } from '../../react/Button';
import { Sizes, Colors } from '../../ts/enums';
import css from './index.module.scss';

const CTABarSpotlight = (props) => {
  let ctaspotlights = props.fields?.children || [];
  const isEditing = props.sitecoreContext?.pageEditing || false;
  const additionalCSS = props.fields?.additionalCSSClasses?.value ? props.fields.additionalCSSClasses.value : ''; 
  ctaspotlights = isEditing ? ctaspotlights : ctaspotlights.filter(x =>
    (x.fields?.link?.value?.href && x.fields.linkText?.value));

  return (
    ctaspotlights.length > 0 ?
      <section className={`${css.container} ${additionalCSS} `} ><div className={`${css.ctaContainer} single-col-inner`}>
        {
          isEditing ?
            <ul>
              {ctaspotlights?.map((link, index) =>
                <li key={`link-${index}`} >
                  <Link field={link.fields.link} className={css.editingText} >
                  </Link>
                  <Text field={link.fields.linkText} className={css.editingText} />
                </li>
              )}</ul>
            : ctaspotlights?.map((link, index) =>
              <div key={`link-${index}`} className={css.buttonContainer}>
                {
                  <RoutableLink field={link.fields.link} className={css.button} ariaLabel={`${link?.fields?.ARIALabelText?.value || ''}`}>
                    <Button size={Sizes.SMALL} color={Colors.WHITE} className={css.button}>
                      <Text field={link.fields.linkText} />
                    </Button>
                  </RoutableLink>
                }
              </div>
            )
        }
      </div>
      </section >
      : isEditing && <p>Please add Link child items to the datasource to see them here.</p>

  );
}

export default withSitecoreContext()(CTABarSpotlight);